module.exports = __webpack_public_path__ + "static/media/team.77ac0e7e.svg";